import {useEffect, useRef} from 'react';
import {checkSpaVersion} from 'src/app/routing/versionService';

/**
 * Hook that checks for SPA version updates when the tab becomes visible.
 * This detects when a new SPA version has been deployed while the user
 * had the tab in the background.
 *
 * Should be used in a top-level component like PrivateOutlet.
 */
export const useVersionCheck = () => {
  const lastCheckRef = useRef<number>(0);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;

      // Throttle checks to once per minute
      const now = Date.now();
      const oneMinute = 60 * 1000;
      if (now - lastCheckRef.current < oneMinute) return;

      lastCheckRef.current = now;
      void checkSpaVersion();
    };

    // Check on mount
    void checkSpaVersion();

    // Check when tab becomes visible
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};
